"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreCitizenshipStepToJSON = exports.PreCitizenshipStepFromJSONTyped = exports.PreCitizenshipStepFromJSON = void 0;
const runtime_1 = require("../runtime");
function PreCitizenshipStepFromJSON(json) {
    return PreCitizenshipStepFromJSONTyped(json, false);
}
exports.PreCitizenshipStepFromJSON = PreCitizenshipStepFromJSON;
function PreCitizenshipStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'birthCountry': json['birthCountry'],
        'birthLocality': json['birthLocality'],
        'birthSubdivision': !runtime_1.exists(json, 'birthSubdivision') ? undefined : json['birthSubdivision'],
        'citizenshipCountry': json['citizenshipCountry'],
        'nonImmigrantVisaStatus': !runtime_1.exists(json, 'nonImmigrantVisaStatus') ? undefined : json['nonImmigrantVisaStatus'],
    };
}
exports.PreCitizenshipStepFromJSONTyped = PreCitizenshipStepFromJSONTyped;
function PreCitizenshipStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'birthCountry': value.birthCountry,
        'birthLocality': value.birthLocality,
        'birthSubdivision': value.birthSubdivision,
        'citizenshipCountry': value.citizenshipCountry,
        'nonImmigrantVisaStatus': value.nonImmigrantVisaStatus,
    };
}
exports.PreCitizenshipStepToJSON = PreCitizenshipStepToJSON;
//# sourceMappingURL=PreCitizenshipStep.js.map